import { formatDuration } from '../components/VideoHeaderStrip';

/**
 * A finding/occurrence/candidate timestamp, video-kind aware (Anshul, 2026-09-26: a photo
 * set's rows carry `start_s === end_s === the 1-based photo number`, never a real video
 * offset, so "6:52" would be a fabricated duration for a photo). `kind` is the video's own
 * `kind` field (`clip` | `walkthrough` | `upload` | `photos`); anything other than
 * `'photos'` renders as an ordinary mm:ss/h:mm:ss duration via `VideoHeaderStrip`'s
 * `formatDuration`, unchanged from before this file existed.
 */
export function formatFindingTime(seconds, kind) {
  if (kind === 'photos') {
    if (seconds === null || seconds === undefined || Number.isNaN(seconds)) return '—';
    return `Photo ${Math.round(seconds)}`;
  }
  return formatDuration(seconds);
}

/**
 * A start/end pair as one line. For a photo set the pair is always equal (the same photo
 * number twice), so it collapses to the single `formatFindingTime` reading rather than
 * printing "Photo 4 – Photo 4".
 */
export function formatFindingRange(startS, endS, kind) {
  if (kind === 'photos') return formatFindingTime(startS, kind);
  if (startS === null || startS === undefined) return '—';
  if (endS === null || endS === undefined || endS === startS) return formatDuration(startS);
  return `${formatDuration(startS)} – ${formatDuration(endS)}`;
}

export default formatFindingTime;
